export function substringUntil(inputString: string, untilString: string): string {
  const index = inputString.indexOf(untilString)
  if (index === -1) {
    return inputString // Return the original string if the substring is not found
  }

  return inputString.substring(0, index + untilString.length) // Get substring until the given string
}
